import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchDirectDepositDashboardSummaryDataModule } from '@perpay-web/fintech/dataModules/fetchDirectDepositDashboardSummary';
import {
    fetchJobsDataModule,
    getIsCompanyUnverified,
} from '@perpay-web/fintech/dataModules/fetchJobs';
import {
    fetchPinwheelABTestDataModule,
    getPinwheelABTestEnabled,
} from '@perpay-web/fintech/dataModules/fetchPinwheelABTest';
import { generalAccountSummaryDataModule } from '@perpay-web/fintech/dataModules/generalAccountSummary';

const PerpayPlusSoloDataModule = composeDataModules([
    generalAccountSummaryDataModule,
    fetchPinwheelABTestDataModule,
    fetchJobsDataModule,
    fetchDirectDepositDashboardSummaryDataModule,
]);

const getRoot = (state) => state.dataModules.perpayPlusSolo;

export const perpayPlusSoloDataModule = PerpayPlusSoloDataModule({
    getRoot,
    key: 'PERPAY_PLUS_SOLO',
});

export const getIsPinwheelEligible = (state) => {
    const isCompanyUnverified = getIsCompanyUnverified(state);
    if (isCompanyUnverified) return true;
    return getPinwheelABTestEnabled(state);
};

export { getIsPayrollPaymentSetupUser } from '@perpay-web/fintech/dataModules/fetchJobs';
